export default "/static/dashboard/build/app/img/v2/a0bc72cf145eec6b94d78028ca3c960a.png";